export const FEATURE_FLAGS = {
  STATEMENTS: 'customerPortalStatements',
}
